import translations from './translations.js';
import style from './style.lit.css';
import CardOptionWrapper from '../card_option_wrapper/element.js';

/**
 * A wrapper for date options.
 *
 * 1. It expects options to be passed via `<ef-date-option>`.
 * 2. If one option contradicts others add this property to it: `unique="true"`.
 */

export default class DateOptionWrapper extends CardOptionWrapper {
  static styles = [CardOptionWrapper.styles, style];

  /** @internal */
  static translations = translations;

  /** @internal */
  get options() {
    return Array.from(this.querySelectorAll('ef-date-option'));
  }
}

DateOptionWrapper.registerTagName('ef-date-option-wrapper');

customElements.get('ef-date-option-wrapper') ||
  customElements.define('ef-date-option-wrapper', DateOptionWrapper);
